<template>
  <section class="modal" v-if="isVisible && popupData" @click.self="closePopup">
    <div class="content-modal">
      <button @click="closePopup" class="close-btn">
        <svg
          data-v-c179c9e8=""
          data-v-2ae8da8a=""
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          fill="currentColor"
          viewBox="0 0 16 16"
          class="bi bi-x"
        >
          <path
            data-v-c179c9e8=""
            stroke="#666"
            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
          ></path>
        </svg>
      </button>

      <div class="content">
        <h2 class="fontsize18">{{ popupData.title }}</h2>
        <figure class="image">
          <img :src="popupData.image" alt="popupData.title" />
        </figure>
        <div
          class="content2 w-100 d-flex flex-column flex-lg-row justify-content-between align-items-center"
        >
          <div
            class="discount-content w-100 d-flex flex-column justify-content-center align-items-center"
          >
            <div
              class="title"
              v-if="popupData && popupData.description"
              v-html="popupData.description"
            ></div>
            <template
              v-if="popupData.coupon_code && popupData.coupon_code.length"
            >
              <!-- <b class="">کدتخفیف:</b> -->
              <div class="content-copy-box">
                <div
                  class="copy-box"
                  v-for="(code, index) in popupData.coupon_code"
                  :key="`code-${code?.id ? code?.id : index}`"
                >
                  <b class="">کدتخفیف:</b>
                  <div class="copy-card">
                    <b class="title text-copy"> {{ code }}</b>
                    <button @click="copyCode(code)" class="btn-copy">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24px"
                        height="24px"
                        fill="none"
                        viewBox="0 0 24 24"
                        class="h-6 w-6 shrink-0 cursor-pointer text-primary-main"
                      >
                        <path
                          fill="var(--color-main)"
                          d="M11.1 22.75H6.9c-3.91 0-5.65-1.74-5.65-5.65v-4.2c0-3.91 1.74-5.65 5.65-5.65h4.2c3.91 0 5.65 1.74 5.65 5.65v4.2c0 3.91-1.74 5.65-5.65 5.65m-4.2-14c-3.1 0-4.15 1.05-4.15 4.15v4.2c0 3.1 1.05 4.15 4.15 4.15h4.2c3.1 0 4.15-1.05 4.15-4.15v-4.2c0-3.1-1.05-4.15-4.15-4.15z"
                        ></path>
                        <path
                          fill="var(--color-main)"
                          d="M17.1 16.75H16c-.41 0-.75-.34-.75-.75v-3.1c0-3.1-1.05-4.15-4.15-4.15H8c-.41 0-.75-.34-.75-.75V6.9c0-3.91 1.74-5.65 5.65-5.65h4.2c3.91 0 5.65 1.74 5.65 5.65v4.2c0 3.91-1.74 5.65-5.65 5.65m-.35-1.5h.35c3.1 0 4.15-1.05 4.15-4.15V6.9c0-3.1-1.05-4.15-4.15-4.15h-4.2c-3.1 0-4.15 1.05-4.15 4.15v.35h2.35c3.91 0 5.65 1.74 5.65 5.65z"
                        ></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </template>
            <a
              v-if="popupData && popupData.button_text"
              :href="popupData?.button_link ?? ''"
              class="btn-buy"
              >{{ popupData?.button_text ?? "" }}</a
            >
          </div>
        </div>
      </div>
    </div>

    <div class="alertBox" :class="alert ? 'show' : 'close'">
      <span>{{ alertContent.content }}</span>
      <span class="icone">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="m9.55 15.15l8.475-8.475q.3-.3.7-.3t.7.3t.3.713t-.3.712l-9.175 9.2q-.3.3-.7.3t-.7-.3L4.55 13q-.3-.3-.288-.712t.313-.713t.713-.3t.712.3z"
          />
        </svg>
      </span>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
      timer: null,
      delay: 0,
      alert: false,
      alertContent: {
        content: null,
        is_success: false,
      },
    };
  },
  mounted() {
    this.startTimer();
  },
  computed: {
    popupData() {
      const popup = this.$store.getters["front/getPopup"];
      if (popup != null) {
        this.delay = popup.display_delay;
      }
      return popup;
    },
  },
  methods: {
    showAlert() {
      this.alert = true;
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    async copyCode(code) {
      try {
        await navigator.clipboard.writeText(code);

        this.alert = true;
        this.alertContent.content = "کپی شد";
        this.alertContent.is_success = true;
        this.showAlert();
      } catch (err) {
        this.alert = true;
        this.alertContent.content = "کپی با خطا مواجه شد، دوباره امتحان کنید";
        this.showAlert();
      }
    },
    startTimer() {
      this.timer = setTimeout(() => {
        this.isVisible = true;
      }, this.delay);
    },
    closePopup() {
      this.isVisible = false;
    },
  },
  beforeDestroy() {
    if (this.timer) clearTimeout(this.timer);
  },
};
</script>

<style scoped>
.modal * {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.modal {
  width: 100vw;
  height: 100vh;
  background: #0000009c;
  backdrop-filter: blur(5px);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  display: grid;
  place-items: center;
}

.content-modal {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  width: 500px;
  max-height: 80%;
  overflow: auto;
  background: white;
  padding: 2rem;
  border-radius: 8px;
}
.content-copy-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 10px;
  flex-wrap: wrap;
}
.border-l {
  border-left: 1px var(--color-main) solid;
}
img {
  width: auto;
  max-width: 100%;
}
.btn-buy {
  background-color: var(--color-main);
  color: white;
  text-align: center;
  padding: 6px 8px;
  border-radius: 8px;
  width: 100%;
}
.discount-content {
  gap: 16px;
}
.alertBox {
  position: absolute;
  min-width: 230px;
  top: 0%;
  opacity: 0;
  padding: 10px !important;
  border-radius: 8px;
  display: flex;
  color: white;
  justify-content: center;
  gap: 4px;
  left: 50%;
  transform: translateX(-50%);
  background: oklch(72.3% 0.219 149.579);
  transition: all 0.5s linear;
}
.copy-box {
  display: flex;
  align-items: center;
  gap: 8px;
}
.copy-card {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #fbcfe8;
  background: #fdf2f8;

  padding: 8px 8px 4px !important;
  border-radius: 8px;
}
.btn-copy {
  display: flex;
  align-items: center;
  padding-inline: 2px;
}

.icone {
  display: flex;
}

.icone svg {
  width: 24px;
  height: 24px;
}

.alertBox.close {
  top: 0%;
  opacity: 0;
}

.alertBox.show {
  top: 5%;
  opacity: 1;
  animation: showAlert 5s linear 0 1 forwards;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
}

.copy-box button {
  display: flex !important;
  cursor: pointer;
}

.close-btn {
  position: absolute;
  top: 5px;
  left: 5px;
  display: flex;
  background: unset;
  border: unset;
}

.content-modal figure {
  margin-inline: auto;
}

.content-modal img {
  width: 100%;
}

.add-bale {
  background: linear-gradient(11deg, #2f4880, #40ad9f, #47f7b9);
  border-radius: 8px;

  color: white;
  padding: 4px 22px;
  display: inline-block;
}

.title {
  font-weight: 700;
  font-size: 16px;
  line-height: 1.5;
  text-align: center;
}

.fontsize18 {
  font-weight: 800;
  font-size: 20px;
  line-height: 1.5;
  text-align: center;
}

@media screen and (max-width: 1024px) {
  .border-l {
    border-left: unset;
  }

  .discount-content {
    width: 100%;
  }

  .content2 {
    gap: 10px;
  }
}

@media screen and (max-width: 568px) {
  .content-modal {
    gap: 1rem;
    width: 100%;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .fontsize18 {
    font-size: 18px;
  }
  .title {
    font-size: 16px;
    line-height: 1.5;
  }
  .modal {
    display: flex;
    align-items: flex-end;
  }
}
</style>
